import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
//Styling
import styled from "styled-components";

import toTop from '../../../../features/toTop';

//Import Action
import { filterCategories } from '../../../../../action';

function CategoriesMobile(props) {
  const { filterCategories, filter, categories, productsCatalog, handleCategories, cleanCategories } = props;

  const [category, setCategory] = useState("");

  const getCountCategories = (item) => {
    const cat1 = [item && item.category_id];
    const cat2 = item && item.all_children ? item.all_children.map((child) => child.category_id) : [];
    const con = cat1.concat(cat2);

    let test = [];
    if (item && item.all_children) {
      item.all_children.forEach((child) => child.all_children.forEach((grand) => {test.push(grand.category_id)}))
    }
    const id = con.concat(test);

    return productsCatalog.filter((product) => id.includes(product.category_id)).length;
  }

  const getCategory = (e, item) => {
    e.preventDefault();
    setTimeout(() => {
      toTop();
    }, 100);
    filterCategories(item);
    handleCategories();
  }

  const getCat = (e, item) => {
    e.preventDefault();
    setTimeout(() => {
      toTop();
    }, 100);
    filterCategories(item);
  }

  const filteredCat = filter.category;

  const p1 = categories.find(a => a.all_children.find(b => b.category_id === filter.category.category_id));
  const p2 = categories.find(a => a.all_children.find(b => b.all_children.find(c => c.category_id === filter.category.category_id)));

  const ch = p2 ? p2.all_children.find(a => a.category_id === filter.category.category_parent_id) : null;

  return (
    <Cat>
      {
        !filteredCat ? 
          <>
            {
              categories.map((obj) => 
                obj.category_active && getCountCategories(obj) > 0 ? (
                    <li key={obj.category_id}>
                      <Link to="#" onClick={(e) => setCategory(obj)} style={{fontWeight: category.category_id === obj.category_id ? "600" : "normal"}}>{obj.category_name}&nbsp;<span>({getCountCategories(obj)})</span></Link>
                    </li>
                  )
                : ""
              )
            }
            <Link to="" onClick={(e) => getCategory(e, category)} className={`show-products${category ? " active" : ""}`}>POKAŻ PRODUKTY ({getCountCategories(category)})</Link>
          </>
        : 
        <>
          <li>
            <Link to="#" onClick={(e) => cleanCategories(e)}>Wszystkie</Link>
          </li>
          <li className="parent" onClick={(e) => getCat(e, ch ? ch : p1 ? p1 : "")} style={{cursor:'pointer'}}>
            {filter.category.category_name}&nbsp;
            <span>({getCountCategories(filter.category)})</span>
          </li>
          {
            filteredCat.all_children.map((obj) => (
              obj.category_active && getCountCategories(obj) > 0 ? (
                  <ul key={obj.category_id}>
                    <li>
                      <Link to="#" onClick={(e) => setCategory(obj)} style={{fontWeight: category.category_id === obj.category_id ? "600" : "normal"}}>{obj.category_name}&nbsp;<span>({getCountCategories(obj)})</span></Link>
                    </li>
                  </ul>
                )
              : ""
            ))
          }
          <Link to="" onClick={(e) => getCategory(e, category)} className={`show-products${category ? " active" : ""}`}>POKAŻ PRODUKTY ({getCountCategories(category)})</Link>
        </>
      }
    </Cat>
  )
}

const Cat = styled.ul`
  list-style: none;
  position: absolute;
  z-index: 9999;
  background-color: #fff;
  width: 100%;
  font-size: 1.8rem;

  li {
    list-style: none;
    border-bottom: 1px solid #c5c5c5;

    &.parent {
      font-weight: 700;
      color: #ff6a00;
      padding: 2rem 2.5rem;
      padding-left: 3.5rem;
    }

    span {
      color: #899296;
      font-weight: normal;
    }

    a {
      display: block;
      padding: 2rem 2.5rem;

      &:active {
        font-weight: 600;
      }
    }
  }

  ul > li > a {
    padding-left: 5rem;
  }

  a {

    &.show-products {
      background-color: #c5c5c5;
      pointer-events: none;
      display: block;
      width: 100%;
      color: #fff;
      text-align: center;
      font-weight: 600;
      padding: 2rem 0;

      &.active {
        background-color: #ff6a00;
        pointer-events: auto;
      }
    }
  }
`

const mapStateToProps = (state) => {
  return {
    filter: state.filter ? state.filter : [],
    categories: state.categories.categories ? state.categories.categories : [],
    manufacturers: state.manufacturers.manufacturers ? state.manufacturers.manufacturers : [],
  }
}

export default connect(mapStateToProps, { filterCategories })(CategoriesMobile);